import React from 'react';

const HilfeRingnummer = () => {
  return(
    <div>
      <p>
        Die Ringnummern werden in der BRD von den Verbänden BNA (Bundesverband für fachgerechten Natur-, Tier- und Artenschutz e.V.)
        und ZZF (Zentralverband Zoologischer Fachbetriebe Deutschlands e.V.) ausgegeben. 
        Sie dient zur eindeutigen Identifizierung des Tieres.
      </p>
    </div>
  )
}

export default HilfeRingnummer;
